import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า SGPT โดยใช้ค่าปกติจาก medium.json
 */
export default async (value, age, gender) => {
  return await checkWithMediumJson(value, 'SGPT (ALT)', gender, age, 'SGPT');
};
